import { z } from 'zod';

export const connectedAppProviderSchema = z.enum(['secrets-manager', 'managed-secret-ref']);
export type ConnectedAppProvider = z.infer<typeof connectedAppProviderSchema>;

export const connectedAppConfigSchema = z.object({
  clientId: z.string(),
  scopes: z.string(),
  issuerUrl: z.string(),
});

export const connectedAppLegacySecretDataSchema = connectedAppConfigSchema.extend({
  clientSecret: z.string(),
});

// Runtime OAuth data used server-side after all secret references are resolved.
export const connectedAppDataSchema = connectedAppLegacySecretDataSchema;

export const connectedAppManagedSecretRefDataSchema = connectedAppConfigSchema.extend({
  clientSecretManagedSecretIdentifier: z.string(),
});

// API responses never return the raw client secret.
export const connectedAppDetailsDataSchema = connectedAppConfigSchema.extend({
  clientSecretManagedSecretIdentifier: z.string().nullable(),
});

export const connectedAppsTableItemSchema = z.object({
  id: z.number(),
  identifier: z.string(),
  name: z.string(),
  createdOn: z.coerce.date(),
  createdBy: z
    .object({
      id: z.number(),
      name: z.string(),
    })
    .nullable(),
});

export const connectedAppSchema = z.object({
  id: z.number(),
  identifier: z.string(),
  secretRef: z.string().nullable(),
  provider: connectedAppProviderSchema,
  name: z.string(),
});
export type ConnectedApp = z.infer<typeof connectedAppSchema>;

export const connectedAppDetailsSchema = z.object({
  id: z.coerce.number(),
  identifier: z.string(),
  provider: connectedAppProviderSchema,
  name: z.string(),
  data: connectedAppDetailsDataSchema,
});

export type ConnectedAppDetails = z.infer<typeof connectedAppDetailsSchema>;
